import { Entity, World } from "ecsy";
import Yeti from "../components/yeti";
import { Player } from "../components/player";
import DisposableSystem from "@/game/libs/engine/root/disposable-system";
import { getPack } from "@/game/libs/engine/loader/asset-loader";
import ObstacleSystem from "@/game/skifree/ecs/systems/ObstacleSystem";
import Heart from "../components/heart";
import { getLevel } from "@/game/skifree/difficulty";

export default class YetiSystem extends DisposableSystem<any> {
  execute(delta: number, time: number) {
    var yetiEntity: Entity = this.queries.yeti.results[0];
    var playerEntity: Entity = this.queries.player.results[0];
    var hearts: Array<Entity> = this.queries.heart.results;
    var world: World = (this as any).world;

    if (yetiEntity && playerEntity) {
      var yeti = yetiEntity.getComponent(Yeti);
      var player = playerEntity.getComponent(Player);

      if (player.y > 0) {
        var a_ = angle(yeti.x, yeti.y, player.x, player.y);
        var d_ = distance(yeti.x, yeti.y, player.x, player.y);

        if (d_ < 10) {
          (getPack().sound.yetiDeath as Howl).play();
          yeti.sprite.alpha = 0;
          player.sprite.play("EOTP_skier_grabbed", () => {
            ObstacleSystem.updateHearts(0, hearts);
            player.sprite.loop("EOTP_skier_hug");
            window.setTimeout(() => {
              player.endGame(this.createScore(player.y));
            }, 2000);
          });
          world.stop();
          return;
        }

        var x = Math.cos(a_) * this.getSpeed(player.y) * delta;
        var y = Math.sin(a_) * this.getSpeed(player.y) * delta;

        yeti.x += x;
        yeti.y += y;
        yeti.sprite.x = yeti.x;
        yeti.sprite.y = yeti.y;
      }
    }
  }

  public getSpeed(distance: number): number {
    return YetiSystem.SPEED + 2 * getLevel(distance);
  }

  public dispose() {}

  createScore(distance: number): number {
    return Math.floor(distance / 10);
  }
  private static SPEED = 230;
}

function angle(x1: number, y1: number, x2: number, y2: number): number {
  var dy = y2 - y1;
  var dx = x2 - x1;
  return Math.atan2(dy, dx);
}

function distance(x1: number, y1: number, x2: number, y2: number): number {
  var a = x1 - x2;
  var b = y1 - y2;
  return Math.sqrt(a * a + b * b);
}

(YetiSystem as any).queries = {
  yeti: {
    components: [Yeti]
  },
  player: {
    components: [Player]
  },
  heart: {
    components: [Heart]
  }
};
